define("shared/utils/object-methods/distinct", ["exports", "@ember/utils"], function (_exports, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.filterDistinctObjects = _exports.areObjectsDistinct = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/utils"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class filterDistinctObjects
   * @extends Utils
   */
  /**
   * Determines if two objects are distinct
   * I.e. if all values in object A are
   * not contained in any other object in the array
   *
   * @method areObjectsDistinct
   * @param {Object} objectA
   * @param {Object} objectB
   *
   * @return {Boolean} Whether objectA and objectB are distinct
   */
  const areObjectsDistinct = (objectA, objectB) => {
    for (const key in objectA) {
      if (Object.prototype.hasOwnProperty.call(objectB, key)) {
        if (objectB[key] !== objectA[key]) {
          return true;
        }
      } else {
        return true;
      }
    }
    return false;
  };

  /**
   * Filters the distinct objects out of the array of objects.
   *
   * @method filterDistinctObjects
   * @param {Array<Object>} data Array of objects with potential duplicates
   *
   * @return {Array<Object>} Array of distinct objects
   */
  _exports.areObjectsDistinct = areObjectsDistinct;
  const filterDistinctObjects = arr => {
    if (!arr || (0, _utils.isEmpty)(arr)) {
      return arr;
    }
    return arr.reduce((uniqueArray, currentObject) => {
      const isDistinct = uniqueArray.findIndex(uniqueObject => !areObjectsDistinct(uniqueObject, currentObject)) < 0;
      return isDistinct ? [...uniqueArray, currentObject] : uniqueArray;
    }, []);
  };
  _exports.filterDistinctObjects = filterDistinctObjects;
});